import React, { useState } from "react";
import { Row, Form, Button, Input, Upload, Spin } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import Layout from "../../../layout/Dashboard";
import { useHistory, Link } from "react-router-dom";
import "./add.css";
import firebase from "../../../config/FirebaseConfig";

export default function Add() {
  const history = useHistory();
  const storage = firebase.storage();
  const ref = firebase.firestore().collection("articles");
  const [loading, setLoading] = useState(false);
  const [image, setImage] = useState([]);
  const onChangeImage = ({ file, onSuccess }) => {
    setTimeout(() => {
      setImage([file]);
      onSuccess("ok");
    }, 0);
  };

  const handleFormSubmit = (values) => {
    setLoading(true);
    storage
      .ref(`articles/${image[0].name}`)
      .put(image[0])
      .then(() => {
        storage
          .ref("articles")
          .child(image[0].name)
          .getDownloadURL()
          .then((url) => {
            ref.add({
              title: values.title,
              content: values.content,
              imgPath: url,
              createdAt: firebase.firestore.Timestamp.now(),
            });
            setLoading(false);
            history.push("/dashboard/article");
          })
          .catch((err) => {
            setLoading(false);
            console.log(err);
          });
      });
  };

  const formLayout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
  };

  return (
    <div id="article_create">
      <Layout>
        <div className="navbar">
          <Link to="/dashboard/article">
            <LeftOutlined /> &nbsp; Tulis Artikel
          </Link>
        </div>
        <Form
          name="basic"
          className="form"
          onFinish={handleFormSubmit}
          {...formLayout}
        >
          <Row justify="end" className="row">
            <Button className="button_secondary" htmlType="submit">
              {loading ? <Spin /> : null} Publish Artikel
            </Button>
          </Row>

          <Form.Item
            labelCol={{ span: 24 }}
            name="title"
            label="Judul"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item label="Gambar">
            <Upload
              customRequest={onChangeImage}
              fileList={image}
              onRemove={() => {
                setImage([]);
              }}
              name="sip"
            >
              <div>
                <Button className="button_primary">Upload</Button>
              </div>
            </Upload>
          </Form.Item>

          <Form.Item
            labelCol={{ span: 24 }}
            name="content"
            label="Isi Artikel"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input.TextArea />
          </Form.Item>
        </Form>
      </Layout>
    </div>
  );
}
